import { __rest } from "tslib";
import React from 'react';
import { HelpPopover } from '@gravity-ui/components';
import { Popover, Text } from '@gravity-ui/uikit';
import { GroupIndent } from '../../';
import { COMMON_POPOVER_PLACEMENT, COMMON_TITLE_MAX_WIDTH, ErrorWrapper } from '../../../';
import { isArraySpec, isObjectSpec, } from '../../../../core';
import { block } from '../../../utils';
import './Section.css';
const b = block('section');
const SectionBase = (_a) => {
    var _b;
    var { name, spec, titleSize, withIndent, ignoreDescription, descriptionAsSubtitle, children } = _a, restProps = __rest(_a, ["name", "spec", "titleSize", "withIndent", "ignoreDescription", "descriptionAsSubtitle", "children"]);
    const meta = restProps.meta;
    const arrOrObjFlag = isArraySpec(spec) || isObjectSpec(spec);
    const titleRef = React.useRef(null);
    let content = children;
    if (meta) {
        content = (React.createElement(ErrorWrapper, { name: name, meta: meta, withoutChildErrorStyles: arrOrObjFlag }, content));
    }
    if (withIndent) {
        content = React.createElement(GroupIndent, null, content);
    }
    let description;
    if (spec.viewSpec.layoutDescription && !ignoreDescription) {
        if (descriptionAsSubtitle) {
            description = (React.createElement("div", { className: b('description'), dangerouslySetInnerHTML: {
                    __html: spec.viewSpec.layoutDescription,
                } }));
        }
        else {
            description = (React.createElement(Text, { className: b('note') },
                React.createElement(HelpPopover, { htmlContent: spec.viewSpec.layoutDescription, placement: ['bottom', 'top'] })));
        }
    }
    const layoutTitle = spec.viewSpec.layoutTitle;
    const layoutTitlePopoverDisabled = (((_b = titleRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0) <= COMMON_TITLE_MAX_WIDTH;
    return (React.createElement("section", { className: b() },
        layoutTitle ? (React.createElement("div", { className: b('header', {
                'with-popover': !descriptionAsSubtitle,
            }) },
            React.createElement(Popover, { content: layoutTitle, placement: COMMON_POPOVER_PLACEMENT, disabled: layoutTitlePopoverDisabled },
                React.createElement("h2", { className: b('title', { size: titleSize }), ref: titleRef }, layoutTitle)),
            description)) : null,
        React.createElement("div", { className: b('content') }, content)));
};
export const Section = (props) => React.createElement(SectionBase, Object.assign({ titleSize: "m" }, props));
export const Section2 = (props) => React.createElement(SectionBase, Object.assign({ titleSize: "s" }, props));
export const SectionWithSubtitle = (props) => React.createElement(SectionBase, Object.assign({ titleSize: "m", descriptionAsSubtitle: true }, props));
export const SectionWithSubtitle2 = (props) => React.createElement(SectionBase, Object.assign({ titleSize: "s", descriptionAsSubtitle: true }, props));
export const Group = (props) => React.createElement(SectionBase, Object.assign({ titleSize: "m", withIndent: true }, props));
export const Group2 = (props) => React.createElement(SectionBase, Object.assign({ titleSize: "s", withIndent: true }, props));
